const MAX_PINS = 8;

function storageKey(variant) {
  return `vendalist_search_pins_${variant === 'vendor' ? 'vendor' : 'admin'}`;
}

export function readSearchPins(variant) {
  try {
    const raw = localStorage.getItem(storageKey(variant));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.slice(0, MAX_PINS) : [];
  } catch {
    return [];
  }
}

export function isSearchPinned(variant, href) {
  if (!href) return false;
  return readSearchPins(variant).some((entry) => entry.href === href);
}

export function toggleSearchPin(variant, item) {
  if (!item?.href || !item?.label) return readSearchPins(variant);
  try {
    const prev = readSearchPins(variant);
    const exists = prev.some((entry) => entry.href === item.href);
    let next;
    if (exists) {
      next = prev.filter((entry) => entry.href !== item.href);
    } else {
      const nextItem = {
        id: item.id || item.href,
        type: item.type === 'recent' || item.type === 'pinned' ? 'page' : item.type || 'page',
        label: item.label,
        meta: item.meta || 'Pinned',
        href: item.href,
      };
      next = [nextItem, ...prev.filter((entry) => entry.href !== nextItem.href)].slice(
        0,
        MAX_PINS
      );
    }
    localStorage.setItem(storageKey(variant), JSON.stringify(next));
    return next;
  } catch {
    return readSearchPins(variant);
  }
}
